import ProductCell from './ProductCell';

export default ProductCell;
